import { HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'

import { environment } from '@coty/env/environment'

import { AuthStore } from '../auth/auth.store'

/**
 * An HTTP interceptor function that adds an Authorization header with a Bearer token
 * to outgoing HTTP requests if a token is available in the AuthStore.
 *
 * @param req - The outgoing HTTP request to be intercepted.
 * @param next - A function to pass the request to the next handler in the chain.
 * @returns The modified HTTP request with the Authorization header if a token exists,
 *          or the original request if no token is available.
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore)

  const token = authStore.token()

  const isYoshuApiRequest = req.url.startsWith(environment.apiUrl)
  const isLoginRequest = req.method === 'POST' && req.url.includes('/v1/login')

  if (!token || isLoginRequest || !isYoshuApiRequest) return next(req)

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  })

  return next(authReq)
}
